
        <div class="alerts" role="alert">
            <div
                *ngFor="let alert of alerts"
                [ngClass]="{ 'alert.position': true, toast: alert.toast }"
            >
                <ngb-alert type="{{ alert.type }}" close="alert.close(alerts)">
                    <p [innerHTML]="alert.msg"></p>
                </ngb-alert>
            </div>
        </div>
    


// WEBPACK FOOTER //
// ./src/app/shared/alert/alert-error.component.ts.JhiAlertErrorComponent.html